import { useEffect, useRef } from 'react';
import Hammer from 'hammerjs';
import styles from './Block.module.css';

const getImageSrc = (block) => {
  if (!block) return '';
  const { color, type } = block;
  if (type === 'regular') return `/images/teammembers/teammember${color}.png`;
  if (type === 'stripe_horizontal') return `/images/special/stripe_horizontal.png`;
  if (type === 'stripe_vertical') return `/images/special/stripe_vertical.png`;
  if (type === 'bomb') return `/images/special/bomb.png`;
  if (type === 'obstacle') return '/images/special/obstacle.png';
  return '';
};

const Block = ({ block, row, col, onSwipe, onSpecialBlockActivate }) => {
  const blockRef = useRef(null);

  useEffect(() => {
    if (!blockRef.current || !block) return;

    const hammer = new Hammer(blockRef.current);
    hammer.get('pan').set({
      direction: Hammer.DIRECTION_ALL,
      threshold: 5,
    });

    hammer.on('panend', (event) => {
      console.log('Pan detected on block:', row, col, event.direction);

      // Check if the block is a special block
      if (block.type === 'stripe_horizontal' || block.type === 'stripe_vertical' || block.type === 'bomb') {
        onSpecialBlockActivate(row, col, block.type);
        return;
      }

      const deltaX = event.deltaX;
      const deltaY = event.deltaY;
      let direction;

      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        direction = deltaX > 0 ? 'right' : 'left';
      } else {
        direction = deltaY > 0 ? 'down' : 'up';
      }

      onSwipe(row, col, direction);
    });

    return () => {
      hammer.destroy();
    };
  }, [row, col, onSwipe, onSpecialBlockActivate, block]);

  return (
    <div ref={blockRef} className={styles.block}>
      {block && (
        <img
          src={getImageSrc(block)}
          alt={block.type}
          onError={() => console.log(`Failed to load image for block at ${row},${col}: ${block.type}`)}
        />
      )}
    </div>
  );
};

export default Block;